import type { GetPromptResponse } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import type { PromptCard } from '@atlassian/rovo-conversation-actions/prompt-cards';

function isSystemPromptFromApi(p: GetPromptResponse): boolean {
	if (p.isSystemPrompt === true) {
		return true;
	}
	if (p.id.startsWith('sys_')) {
		return true;
	}
	return false;
}

/**
 * Maps API prompt responses to PromptCard objects with user-generated metadata
 */
export function mapApiPromptsToCards(items: GetPromptResponse[]): PromptCard[] {
	return items.map((p) => ({
		id: p.id,
		title: p.title,
		prompt: p.prompt,
		useCase: p.useCase ?? undefined,
		roles: p.roles?.length ? p.roles : undefined,
		appIds: p.appIds?.length ? p.appIds : undefined,
		isFavorited: p.isFavorited,
		shareId: p.id,
		isUserGenerated: !isSystemPromptFromApi(p),
	}));
}
